import { QueryHookOptions, useQuery } from "@apollo/client";
import { BrandsQuery, BrandsQueryVariables } from "../schema";
import queryGQL from "@/Apollo/query/brands.graphql";

export const useBrands = (
  options?: QueryHookOptions<BrandsQuery, BrandsQueryVariables>
) => {
  return useQuery(queryGQL, options);
};
